import { render, staticRenderFns } from "./fodderList.vue?vue&type=template&id=1fb469b4&scoped=true&"
import script from "./fodderList.vue?vue&type=script&lang=js&"
export * from "./fodderList.vue?vue&type=script&lang=js&"
import style0 from "./fodderList.vue?vue&type=style&index=0&id=1fb469b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb469b4",
  null
  
)

export default component.exports